import { GlobalStore, UserStore } from '@roc/feature-app-core';
import { FixFlipStore } from './fixFlipStore';
import { GroundUpStore } from './groundUpStore';
import { StabilizedBridgeStore } from './stabilizedBridgeStore';
import { SinglePropertyRentalStore } from './singlePropertyRentalStore';
import { RentalPortfolioStore } from './rentalPortfolioStore';
import { action, makeObservable, observable } from 'mobx';
import { OtherBridgeStore } from './otherBridgeStore';
import { OtherRentalStore } from './otherRentalStore';

export class ThirdPartyLoansStore {
  fixFlipStore: FixFlipStore;
  groundUpStore: GroundUpStore;
  stabilizedBridgeStore: StabilizedBridgeStore;
  singlePropertyRentalStore: SinglePropertyRentalStore;
  rentalPortfolioStore: RentalPortfolioStore;
  otherBridgeStore: OtherBridgeStore;
  otherRentalStore: OtherRentalStore;

  capitalProviderName: string;

  constructor(globalStore: GlobalStore, userStore: UserStore) {
    this.fixFlipStore = new FixFlipStore(globalStore, userStore);
    this.groundUpStore = new GroundUpStore(globalStore, userStore);
    this.stabilizedBridgeStore = new StabilizedBridgeStore(
      globalStore,
      userStore
    );
    this.singlePropertyRentalStore = new SinglePropertyRentalStore(
      globalStore,
      userStore
    );
    this.rentalPortfolioStore = new RentalPortfolioStore(
      globalStore,
      userStore
    );
    this.otherBridgeStore = new OtherBridgeStore(globalStore, userStore);
    this.otherRentalStore = new OtherRentalStore(globalStore, userStore);

    makeObservable(this, {
      capitalProviderName: observable,
      reset: action,
      setCapitalProviderName: action,
    });
  }

  reset() {
    this.capitalProviderName = undefined;
  }

  setCapitalProviderName(capitalProviderName: string) {
    this.capitalProviderName = capitalProviderName;
  }
}
